import React from "react"
import PropTypes from "prop-types"
import WidgetWrapper from "components/views/widgets/WidgetWrapper"
import { Spacer } from "components/views/atoms/Atoms"
import { Button, FlexContainer } from "@carrotfertility/carotene"
import { useHistory } from "react-router-dom"
import { defineMessage, useIntl } from "react-intl"

const buttonOptions = {
  done: defineMessage({ defaultMessage: "Done" }),
  back: defineMessage({ defaultMessage: "Back" }),
  sending: defineMessage({ defaultMessage: "Sending..." })
}

/** @deprecated */
const WizardWrapper = ({
  back,
  backRoute,
  children,
  done,
  nextDisabled,
  onDone,
  sending,
  title,
  contentWidth,
  nextId = "",
  backText,
  doneText,
  sendingText
}) => {
  const history = useHistory()
  const intl = useIntl()

  const doneMessage = doneText ? doneText : intl.formatMessage(buttonOptions.done)
  const backMessage = backText ? backText : intl.formatMessage(buttonOptions.back)
  const sendingMessage = sendingText ? sendingText : intl.formatMessage(buttonOptions.sending)

  const handleSubmit = (event) => {
    event.preventDefault()
    if (!nextDisabled && !sending) {
      onDone()
    }
  }

  return (
    <WidgetWrapper narrow title={title}>
      <form onSubmit={handleSubmit}>
        <div className={contentWidth}>
          {children}
          <Spacer height={0.5} />
          <FlexContainer gap="16px" justifyContent="flex-end">
            {back && (
              <Button variant="secondary" onClick={() => history.push(backRoute)} enabled={!sending} outline>
                {backMessage}
              </Button>
            )}
            {done && (
              <Button onClick={handleSubmit} id={nextId} enabled={!sending && !nextDisabled}>
                {sending ? sendingMessage : doneMessage}
              </Button>
            )}
          </FlexContainer>
        </div>
      </form>
    </WidgetWrapper>
  )
}

WizardWrapper.propTypes = {
  back: PropTypes.bool,
  backRoute: PropTypes.string,
  backText: PropTypes.string,
  done: PropTypes.bool,
  doneRoute: PropTypes.string,
  doneText: PropTypes.string,
  onDone: PropTypes.func,
  sending: PropTypes.bool,
  sendingText: PropTypes.string,
  title: PropTypes.string,
  contentWidth: PropTypes.string,
  nextDisabled: PropTypes.bool
}

export default WizardWrapper
